import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

// Lazy load components with error handling
const lazyLoad = (importFunc: () => Promise<any>) => {
  return lazy(() => 
    importFunc().catch((error) => {
      console.error('Failed to load component:', error);
      // You can return a fallback component here if needed
      return { default: () => <div>Error loading component</div> };
    })
  );
};

const HomePage = lazyLoad(() => import('../pages/home/page'));
const ProductsPage = lazyLoad(() => import('../pages/products/page'));
const ServicesPage = lazyLoad(() => import('../pages/services/page'));
const ServiceDetailPage = lazyLoad(() => import('../pages/service-detail/page'));
const BlogPage = lazyLoad(() => import('../pages/blog/page'));
const CheckoutPage = lazyLoad(() => import('../pages/checkout/page'));
const AboutPage = lazyLoad(() => import('../pages/about/page'));
const DashboardPage = lazyLoad(() => import('../pages/dashboard/page'));

// Wrap component with Suspense
const withSuspense = (Component: React.ComponentType<any>) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(HomePage),
  },
  {
    path: '/products',
    element: withSuspense(ProductsPage),
  },
  {
    path: '/services',
    element: withSuspense(ServicesPage),
  },
  {
    path: '/service-detail',
    element: withSuspense(ServiceDetailPage),
  },
  {
    path: '/blog',
    element: withSuspense(BlogPage),
  },
  {
    path: '/checkout',
    element: withSuspense(CheckoutPage),
  },
  {
    path: '/about',
    element: withSuspense(AboutPage),
  },
  {
    path: '/dashboard',
    element: withSuspense(DashboardPage),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
